export const MANAGEMENT_OFFICER_NAME = 'name';
export const MANAGEMENT_OFFICER_ORDER_NUMBER = 'order_number';
export const MANAGEMENT_OFFICER_POSITION = 'position';
export const MANAGEMENT_OFFICER_FILES = 'files';
